// 此文件用于通过script标签直接引入

// 导入LoginModal模块
import { LoginModal, showLoginModal } from './index.js';

// 强制挂载到全局对象
window.LoginModal = LoginModal;
window.showLoginModal = showLoginModal;

console.log('登录组件已加载，可通过window.showLoginModal()调用');
